<svg width="184" height="90" viewBox="0 0 184 90" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="2" y="30" width="28" height="28" rx="8" fill="#F6DC72"/>
<path d="M30 44H37.1882C42.1588 44 46.1882 39.9706 46.1882 35V25C46.1882 20.0294 50.2177 16 55.1882 16H73" stroke="#D5D5D5" stroke-width="2"/>
<path d="M30 44H37.1882C42.1588 44 46.1882 48.0294 46.1882 53V65C46.1882 69.9706 50.2177 74 55.1882 74H73" stroke="#D5D5D5" stroke-width="2"/>
<path d="M30 44H143" stroke="#D5D5D5" stroke-width="2"/>
<circle cx="51.5" cy="16.5" r="2.5" fill="black"/>
<circle cx="94.5" cy="44.5" r="2.5" fill="black"/>
<circle cx="65.5" cy="74.5" r="2.5" fill="black"/>
<circle cx="63.5" cy="44.5" r="2.5" fill="black"/>
<rect x="73" y="2" width="28" height="28" rx="8" fill="#B0D9FF"/>
<rect x="109" y="30" width="28" height="28" rx="8" fill="#EEBED4"/>
<rect x="142" y="30" width="28" height="28" rx="8" fill="#EEBED4"/>
<rect x="73" y="60" width="28" height="28" rx="8" fill="#61BC76"/>
</svg>
